'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useCallback } from 'react';
import { MultiSelectDropdown } from '@/components/ui/multi-select-dropdown';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Badge } from '@/components/ui/badge';
import { Check, ChevronDown, X } from 'lucide-react';
import { cn } from '@/lib/utils';
interface TagMultiSelectorOption {
  id: string;
  label: string;
}
interface TagMultiSelectorProps {
  label: string;
  placeholder?: string;
  searchPlaceholder?: string;
  options: readonly TagMultiSelectorOption[] | TagMultiSelectorOption[];
  selectedIds: string[];
  onSelectionChange: (ids: string[]) => void;
  disabled?: boolean;
  /** 'dropdown' uses the existing MultiSelectDropdown; 'combobox' uses a Popover+Command autocomplete with chips */
  mode?: 'dropdown' | 'combobox';
}
export function TagMultiSelector(t0) {
  const $ = _c(16);
  const {
    label,
    placeholder: t1,
    searchPlaceholder: t2,
    options,
    selectedIds,
    onSelectionChange,
    disabled: t3,
    mode: t4
  } = t0;
  const placeholder = t1 === undefined ? "Select options..." : t1;
  const searchPlaceholder = t2 === undefined ? "Search..." : t2;
  const disabled = t3 === undefined ? false : t3;
  const mode = t4 === undefined ? "dropdown" : t4;
  if (mode === "dropdown") {
    let t5;
    if ($[0] !== disabled || $[1] !== label || $[2] !== onSelectionChange || $[3] !== options || $[4] !== placeholder || $[5] !== searchPlaceholder || $[6] !== selectedIds) {
      t5 = <DropdownMode label={label} placeholder={placeholder} searchPlaceholder={searchPlaceholder} options={options} selectedIds={selectedIds} onSelectionChange={onSelectionChange} disabled={disabled} />;
      $[0] = disabled;
      $[1] = label;
      $[2] = onSelectionChange;
      $[3] = options;
      $[4] = placeholder;
      $[5] = searchPlaceholder;
      $[6] = selectedIds;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  let t5;
  if ($[8] !== disabled || $[9] !== label || $[10] !== onSelectionChange || $[11] !== options || $[12] !== placeholder || $[13] !== searchPlaceholder || $[14] !== selectedIds) {
    t5 = <ComboboxMode label={label} placeholder={placeholder} searchPlaceholder={searchPlaceholder} options={options} selectedIds={selectedIds} onSelectionChange={onSelectionChange} disabled={disabled} />;
    $[8] = disabled;
    $[9] = label;
    $[10] = onSelectionChange;
    $[11] = options;
    $[12] = placeholder;
    $[13] = searchPlaceholder;
    $[14] = selectedIds;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function DropdownMode(t0) {
  const $ = _c(10);
  const {
    label,
    placeholder,
    searchPlaceholder,
    options,
    selectedIds,
    onSelectionChange,
    disabled
  } = t0;
  const t1 = options as TagMultiSelectorOption[];
  let t2;
  if ($[0] !== t1) {
    t2 = t1.map(_temp);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const multiSelectOptions = t2;
  let t3;
  if ($[2] !== disabled || $[3] !== label || $[4] !== multiSelectOptions || $[5] !== onSelectionChange || $[6] !== placeholder || $[7] !== searchPlaceholder || $[8] !== selectedIds) {
    t3 = <MultiSelectDropdown label={label} placeholder={placeholder} options={multiSelectOptions} selectedIds={selectedIds} onSelectionChange={onSelectionChange} showChips={true} showSummaryInTrigger={false} showBulkActions={true} disabled={disabled} showSearch={true} searchPlaceholder={searchPlaceholder} />;
    $[2] = disabled;
    $[3] = label;
    $[4] = multiSelectOptions;
    $[5] = onSelectionChange;
    $[6] = placeholder;
    $[7] = searchPlaceholder;
    $[8] = selectedIds;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(opt) {
  return {
    id: opt.id,
    label: opt.label
  };
}
function ComboboxMode(t0) {
  const $ = _c(81);
  const {
    label,
    placeholder,
    searchPlaceholder,
    options,
    selectedIds,
    onSelectionChange,
    disabled
  } = t0;
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  const optionsArray = options as TagMultiSelectorOption[];
  let T0;
  let T1;
  let selectedOptions;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let toggleOption;
  if ($[0] !== disabled || $[1] !== label || $[2] !== onSelectionChange || $[3] !== open || $[4] !== optionsArray || $[5] !== selectedIds) {
    let t13;
    if ($[22] !== selectedIds) {
      t13 = opt => selectedIds.includes(opt.id);
      $[22] = selectedIds;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    selectedOptions = optionsArray.filter(t13);
    let t14;
    if ($[24] !== onSelectionChange || $[25] !== selectedIds) {
      t14 = id => {
        if (selectedIds.includes(id)) {
          onSelectionChange(selectedIds.filter(s => s !== id));
        } else {
          onSelectionChange([...selectedIds, id]);
        }
      };
      $[24] = onSelectionChange;
      $[25] = selectedIds;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    toggleOption = t14;
    let t15;
    if ($[27] !== onSelectionChange || $[28] !== selectedIds) {
      t15 = (id_0, e) => {
        e.preventDefault();
        e.stopPropagation();
        onSelectionChange(selectedIds.filter(s_0 => s_0 !== id_0));
      };
      $[27] = onSelectionChange;
      $[28] = selectedIds;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    const removeOption = t15;
    t11 = "space-y-1.5";
    if ($[30] !== label) {
      t12 = <label className="text-sm font-medium leading-none">{label}</label>;
      $[30] = label;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    T1 = Popover;
    t9 = open;
    t10 = setOpen;
    T0 = PopoverTrigger;
    t7 = true;
    t8 = disabled;
    t3 = "button";
    t4 = "combobox";
    t5 = open;
    const t16 = disabled && "cursor-not-allowed opacity-50";
    if ($[32] !== t16) {
      t6 = cn("flex min-h-[38px] w-full items-center justify-between rounded-md border border-input bg-background px-3 py-1.5 text-sm ring-offset-background", "focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2", "cursor-pointer", t16);
      $[32] = t16;
      $[33] = t6;
    } else {
      t6 = $[33];
    }
    t1 = "flex flex-1 flex-wrap items-center gap-1";
    let t17;
    if ($[34] !== removeOption) {
      t17 = opt_0 => <Badge key={opt_0.id} variant="secondary" className="gap-1 rounded-sm px-1.5 py-0 text-xs font-normal">{opt_0.label}<button type="button" className="ml-0.5 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 cursor-pointer" onMouseDown={e_0 => removeOption(opt_0.id, e_0)} aria-label={`Remove ${opt_0.label}`}><X className="h-3 w-3" /></button></Badge>;
      $[34] = removeOption;
      $[35] = t17;
    } else {
      t17 = $[35];
    }
    t2 = selectedOptions.map(t17);
    $[0] = disabled;
    $[1] = label;
    $[2] = onSelectionChange;
    $[3] = open;
    $[4] = optionsArray;
    $[5] = selectedIds;
    $[6] = T0;
    $[7] = T1;
    $[8] = selectedOptions;
    $[9] = t1;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = toggleOption;
  } else {
    T0 = $[6];
    T1 = $[7];
    selectedOptions = $[8];
    t1 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
    toggleOption = $[21];
  }
  let t13;
  if ($[36] !== placeholder || $[37] !== selectedOptions.length) {
    t13 = selectedOptions.length === 0 && <span className="text-muted-foreground">{placeholder}</span>;
    $[36] = placeholder;
    $[37] = selectedOptions.length;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t1 || $[40] !== t13 || $[41] !== t2) {
    t14 = <div className={t1}>{t2}{t13}</div>;
    $[39] = t1;
    $[40] = t13;
    $[41] = t2;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t14 || $[45] !== t3 || $[46] !== t4 || $[47] !== t5 || $[48] !== t6) {
    t16 = <button type={t3} role={t4} aria-expanded={t5} className={t6}>{t14}{t15}</button>;
    $[44] = t14;
    $[45] = t3;
    $[46] = t4;
    $[47] = t5;
    $[48] = t6;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== T0 || $[51] !== t16 || $[52] !== t7 || $[53] !== t8) {
    t17 = <T0 asChild={t7} disabled={t8}>{t16}</T0>;
    $[50] = T0;
    $[51] = t16;
    $[52] = t7;
    $[53] = t8;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = e_1 => {
      e_1.preventDefault();
      inputRef.current?.focus();
    };
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== searchPlaceholder) {
    t19 = <CommandInput ref={inputRef} placeholder={searchPlaceholder} />;
    $[56] = searchPlaceholder;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <CommandEmpty>No results found.</CommandEmpty>;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== optionsArray || $[60] !== selectedIds || $[61] !== toggleOption) {
    let t22;
    if ($[63] !== selectedIds || $[64] !== toggleOption) {
      t22 = opt_1 => {
        const isSelected = selectedIds.includes(opt_1.id);
        return <CommandItem key={opt_1.id} value={opt_1.label} onSelect={() => toggleOption(opt_1.id)} className="cursor-pointer"><div className={cn("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border", isSelected ? "border-primary bg-primary text-primary-foreground" : "border-muted-foreground/40 bg-background")}>{isSelected && <Check className="h-3 w-3" />}</div><span>{opt_1.label}</span></CommandItem>;
      };
      $[63] = selectedIds;
      $[64] = toggleOption;
      $[65] = t22;
    } else {
      t22 = $[65];
    }
    t21 = optionsArray.map(t22);
    $[59] = optionsArray;
    $[60] = selectedIds;
    $[61] = toggleOption;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[66] !== t21) {
    t22 = <CommandList>{t20}<CommandGroup>{t21}</CommandGroup></CommandList>;
    $[66] = t21;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  let t23;
  if ($[68] !== t19 || $[69] !== t22) {
    t23 = <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0" align="start" side="bottom" avoidCollisions={false} onOpenAutoFocus={t18}><Command>{t19}{t22}</Command></PopoverContent>;
    $[68] = t19;
    $[69] = t22;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] !== T1 || $[72] !== t10 || $[73] !== t17 || $[74] !== t23 || $[75] !== t9) {
    t24 = <T1 open={t9} onOpenChange={t10}>{t17}{t23}</T1>;
    $[71] = T1;
    $[72] = t10;
    $[73] = t17;
    $[74] = t23;
    $[75] = t9;
    $[76] = t24;
  } else {
    t24 = $[76];
  }
  let t25;
  if ($[77] !== t11 || $[78] !== t12 || $[79] !== t24) {
    t25 = <div className={t11}>{t12}{t24}</div>;
    $[77] = t11;
    $[78] = t12;
    $[79] = t24;
    $[80] = t25;
  } else {
    t25 = $[80];
  }
  return t25;
}